// import {
//   useGetLocale,
//   useSetLocale,
//   useGetIdentity,
// } from "@pankod/refine-core";
// import {
//   AntdLayout,
//   Space,
//   Menu,
//   Button,
//   Icons,
//   Dropdown,
//   Avatar,
//   Typography,
// } from "@pankod/refine-antd";
// import { useTranslation } from "react-i18next";

import { useState, useEffect } from "react";
import {
    useGetLocale,
    useSetLocale,
    useGetIdentity,
    useTranslate,
    // useList,
} from "@pankod/refine-core";

import {
    AntdLayout,
    Menu,
    Icons,
    Dropdown,
    Input,
    Avatar,
    Typography,
    Space,
    Grid,
    Row,
    Col,
    AutoComplete,
} from "@pankod/refine-antd";

// import RefineReactRouter from "@pankod/refine-react-router-v6";

import { useTranslation } from "react-i18next";
import debounce from "lodash/debounce";

// import { IOrder, IStore, ICourier } from "interfaces";
import "./style.less";

// const { DownOutlined } = Icons;
// const { Text } = Typography;

// export const Header: React.FC = () => {
//   const { i18n } = useTranslation();
//   const locale = useGetLocale();
//   const changeLanguage = useSetLocale();
//   const { data: user } = useGetIdentity();

//   const currentLocale = locale();

//   const menu = (
//     <Menu selectedKeys={currentLocale ? [currentLocale] : []}>
//       {[...(i18n.languages || [])].sort().map((lang: string) => (
//         <Menu.Item
//           key={lang}
//           onClick={() => changeLanguage(lang)}
//           icon={
//             <span style={{ marginRight: 8 }}>
//               <Avatar size={16} src={`/images/flags/${lang}.svg`} />
//             </span>
//           }
//         >
//           {lang === "en" ? "English" : "German"}
//         </Menu.Item>
//       ))}
//     </Menu>
//   );

//   return (
//     <AntdLayout.Header
//       style={{
//         display: "flex",
//         justifyContent: "flex-end",
//         alignItems: "center",
//         padding: "0px 24px",
//         height: "64px",
//         backgroundColor: "#FFF",
//       }}
//     >
//       <Dropdown overlay={menu}>
//         <Button type="link">
//           <Space>
//             <Avatar size={16} src={`/images/flags/${currentLocale}.svg`} />
//             {currentLocale === "en" ? "English" : "German"}
//             <DownOutlined />
//           </Space>
//         </Button>
//       </Dropdown>
//       <Space style={{ marginLeft: "8px" }}>
//         {user?.name && (
//           <Text ellipsis strong>
//             {user.name}
//           </Text>
//         )}
//         {user?.avatar && <Avatar src={user?.avatar} alt={user?.name} />}
//       </Space>
//     </AntdLayout.Header>
//   );
// };



// const { Link } = RefineReactRouter;
const { SearchOutlined, DownOutlined } = Icons;
const { Text } = Typography;
const { useBreakpoint } = Grid;



interface IOptionGroup {
    value: string;
    label: string | React.ReactNode;
}

interface IOptions {
    label: string | React.ReactNode;
    options: IOptionGroup[];
}

export const Header: React.FC = () => {
    const { i18n } = useTranslation();
    const locale = useGetLocale();
    const changeLanguage = useSetLocale();
    const { data: user } = useGetIdentity();
    const screens = useBreakpoint();
    const t = useTranslate();

    const currentLocale = locale();

    // const renderTitle = (title: string) => (
    //     <div className="header-title">
    //         <Text style={{ fontSize: "16px" }}>{title}</Text>
    //         <Link to={`/${title.toLowerCase()}`}>{t("search.more")}</Link>
    //     </div>
    // );

    // const renderItem = (title: string, imageUrl: string, link: string) => ({
    //     value: title,
    //     label: (
    //         <Link to={link} style={{ display: "flex", alignItems: "center" }}>
    //             <Avatar size={64} src={imageUrl} style={{ minWidth: "64px" }} />
    //             <Text style={{ marginLeft: "16px" }}>{title}</Text>
    //         </Link>
    //     ),
    // });

    const [value, setValue] = useState<string>("");
    const [options, setOptions] = useState<IOptions[]>([]);

    // const { refetch: refetchOrders } = useList<IOrder>({
    //     resource: "orders",
    //     config: {
    //         filters: [{ field: "q", operator: "contains", value }],
    //     },
    //     queryOptions: {
    //         enabled: false,
    //         onSuccess: (data) => {
    //             const orderOptionGroup = data.data.map((item) =>
    //                 renderItem(
    //                     `${item.store.title} / #${item.orderNumber}`,
    //                     "/images/default-order-img.png",
    //                     `/orders/show/${item.id}`,
    //                 ),
    //             );
    //             if (orderOptionGroup.length > 0) {
    //                 setOptions((prevOptions) => [
    //                     ...prevOptions,
    //                     {
    //                         label: renderTitle(t("orders.orders")),
    //                         options: orderOptionGroup,
    //                     },
    //                 ]);
    //             }
    //         },
    //     },
    // });

    // const { refetch: refetchStores } = useList<IStore>({
    //     resource: "stores",
    //     config: {
    //         filters: [{ field: "q", operator: "contains", value }],
    //     },
    //     queryOptions: {
    //         enabled: false,
    //         onSuccess: (data) => {
    //             const storeOptionGroup = data.data.map((item) =>
    //                 renderItem(
    //                     item.title,
    //                     "/images/default-store-img.png",
    //                     `/stores/edit/${item.id}`,
    //                 ),
    //             );
    //             if (storeOptionGroup.length > 0) {
    //                 setOptions((prevOptions) => [
    //                     ...prevOptions,
    //                     {
    //                         label: renderTitle(t("stores.stores")),
    //                         options: storeOptionGroup,
    //                     },
    //                 ]);
    //             }
    //         },
    //     },
    // });

    // const { refetch: refetchCouriers } = useList<ICourier>({
    //     resource: "couriers",
    //     config: {
    //         filters: [{ field: "q", operator: "contains", value }],
    //     },
    //     queryOptions: {
    //         enabled: false,
    //         onSuccess: (data) => {
    //             const courierOptionGroup = data.data.map((item) =>
    //                 renderItem(
    //                     `${item.name} ${item.surname}`,
    //                     item.avatar[0].url,
    //                     `/couriers/show/${item.id}`,
    //                 ),
    //             );
    //             if (courierOptionGroup.length > 0) {
    //                 setOptions((prevOptions) => [
    //                     ...prevOptions,
    //                     {
    //                         label: renderTitle(t("couriers.couriers")),
    //                         options: courierOptionGroup,
    //                     },
    //                 ]);
    //             }
    //         },
    //     },
    // });

    const ShowLocaleName = (locale: string| undefined) => {
      switch (locale) {
        case "en":
          return "English";
        case "uk":
          return "Українська";
        case "ru":
          return "Русский";
        default:  
          return "English"; 
        }
    }
    useEffect(() => {
        setOptions([]);
        // refetchOrders();
        // refetchCouriers();
        // refetchStores();
    }, [value]);

    const menu = (
        <Menu selectedKeys={currentLocale ? [currentLocale] : []}>
            {/* {[...(i18n.languages ?? [])].sort().map((lang: string) => ( */}
            {[...(i18n.languages ?? [])].map((lang: string) => (
                <Menu.Item
                    key={lang}
                    onClick={() => changeLanguage(lang)}
                    icon={
                        <span style={{ marginRight: 8 }}>
                            <Avatar
                                size={16}
                                src={`/images/flags/${lang}.svg`}
                            />
                        </span>
                    }
                >
                    {/* {lang === "en" ? "English" : "German"} */}
                    {ShowLocaleName(lang)}
                </Menu.Item>
            ))}
        </Menu>
    );

    return (
        <AntdLayout.Header
            style={{
                padding: "0px 24px",
                height: "64px",
                backgroundColor: "#FFF",
            }}
        >
            <Row align="middle" justify={screens.sm ? "space-between" : "end"}>
                <Col xs={0} sm={12}>
                    <AutoComplete
                        dropdownClassName="header-search"
                        style={{ width: "100%", maxWidth: "550px" }}
                        options={options}
                        filterOption={false}
                        onSearch={debounce(
                            (value: string) => setValue(value),
                            300,
                        )}
                    >
                        <Input
                            size="large"
                            placeholder={t("search.placeholder")}
                            suffix={<SearchOutlined />}
                        />
                    </AutoComplete>
                </Col>
                <Col>
                    <Space size="middle">
                        <Dropdown overlay={menu}>
                            {/* eslint-disable-next-line */}
                            <a
                                style={{ color: "inherit" }}
                                onClick={(e) => e.preventDefault()}
                            >
                                <Space>
                                    <Avatar
                                        size={16}
                                        src={`/images/flags/${currentLocale}.svg`}
                                    />
                                    <div
                                        style={{
                                            display: screens.lg
                                                ? "block"
                                                : "none",
                                        }}
                                    >
                                        {/* {currentLocale === "en"
                                            ? "English"
                                            : "German"} */}
                                        {ShowLocaleName(currentLocale)}
                                        <DownOutlined
                                            style={{
                                                fontSize: "12px",
                                                marginLeft: "6px",
                                            }}
                                        />
                                    </div>
                                </Space>
                            </a>
                        </Dropdown>
                        <Text ellipsis strong>
                            {user?.name}
                        </Text>
                        <Avatar
                            size="large"
                            // src={user?.avatar}
                            style={{ backgroundColor: '#87d068' }}
                            icon={<Icons.UserOutlined />}
                            alt={user?.name}
                        />
                    </Space>
                </Col>
            </Row>
        </AntdLayout.Header>
    );
};
